import React from 'react'
import { Container } from 'reactstrap'

import Breadcrumbs from '../../components/Global/Breadcrumbs'
import ProgramadasTable from './components/Programadas'

const Programadas = () => {
    return (
        <React.Fragment>
            <Container fluid>
                <Breadcrumbs
                    title="Facturación"
                    breadcrumbItem="Facturas Programadas"
                    parentLink="/facturas"
                />

                <ProgramadasTable />
            </Container>
        </React.Fragment>
    )
}

export default Programadas
